//libs
import React, { memo } from 'react';
import { useSelector } from 'react-redux';

//styles
import { Anchor } from './styles';

//context
import { useFetchPage } from 'shared/store/listingV2/hooks';

//selectors
import { getLocation } from 'store/listingV2/selectors';

//constants
import { SCROLLED_ELEMENT } from 'shared/layouts/Listing/Desktop/components/Layout/constants';

//defs
interface PageIOProps {
  setActiveElement: (value: number) => void;
  isLastPage: boolean;
  buttonText: string;
  isLoading?: boolean;
}
const PageIO = ({ setActiveElement, isLastPage, buttonText, isLoading }: PageIOProps) => {
  const { fetchPage } = useFetchPage();
  const { pathname, search } = useSelector(getLocation);
  const params = new URLSearchParams(search);
  const pageNumber = params.get('p');
  params.set('p', pageNumber ? (parseInt(pageNumber) + 1).toString() : '2');
  const nextPageLink = `${pathname}?${params.toString()}`;

  const handleOnVisible = () => {
    !isLastPage && !isLoading && fetchPage();
    setActiveElement(SCROLLED_ELEMENT.PLACEHOLDER);
  };

  return (
    <Anchor href={nextPageLink} once onVisible={handleOnVisible} as="a">
      {buttonText}
    </Anchor>
  );
};
export default memo(PageIO);
